export default "__VITE_ASSET__BICtw$aU__"